module.exports = __webpack_public_path__ + "static/media/TDLM.d6b67b1b.pdf";